import { makeGoalCalculator } from "./makeGoalCalculator";

export default makeGoalCalculator({
  key: "dream-home",
  title: "Dream Home",
  description: "Plan the down payment for your dream home — finance part with a loan, save for the rest.",
  loan: true,
  labels: {
    presentCost: "Current cost of dream home",
    years: "Years until you own your dream home",
    currentSavings: "Current savings for dream home",
    loan: "Funded by home loan",
  },
  defaults: { presentCost: 1_00_00_000, yearsToGoal: 7, loanPct: 80 },
});
